import styled from 'styled-components';

const ContainerHeaderInvoiceStyled = styled.div`
  padding-bottom: 12px;
  border-radius: 8px;
  background-color: #ffffff;
  margin-bottom: 16px;
`;

const TopHeaderInvoiceStyled = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 768px) {
    flex-direction: ${({ accountSelector }) => accountSelector && 'row'};
  }
`;

const MessageContainer = styled.div`
  padding: 0px;
  padding-bottom: 16px;
  display: grid;
  gap: 16px;
  @media (min-width: 769px) {
    padding: 16px 0;
  }
`;

export {
  ContainerHeaderInvoiceStyled,
  TopHeaderInvoiceStyled,
  MessageContainer,
};
